import React from "react";
import WowTooltip from "./WowTooltip";

// Wraps children in the enchant's Wowhead tooltip. itemId is the scroll/kit
// item published by the backend as enchant_item_id; entries without one
// render bare rather than tooltipping the wrong thing.
const EnchantTooltip = ({ itemId, children }) => {
  if (!itemId || itemId <= 0) {
    return children;
  }

  return (
    <WowTooltip type="item" id={itemId}>
      {children}
    </WowTooltip>
  );
};

export default EnchantTooltip;
